import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import Introduction from "./Introduction";
import TestCase from "./TestCase";
import CreatingTestCase from "./CreatingTestCase";
import { Helmet } from "react-helmet-async";


const FrothAI = () => {
  const location = useLocation();
  const title = "AI Test Case Generation Tool | Smarter Test Design";
  const description = "Streamline your test creation process with AI-driven test case generation tool. Scalable software testing, Boost efficiency and deliver better software, faster.";
  return (
    <>
    <Helmet>
  <title>
    {title}
  </title>

  <meta
    name="description"
    content={description}
  />

  <meta
    name="keywords"
    content="AI Test Case Generation Tool"
  />

  <link
    rel="canonical"
    href="https://frothtestops.com/froth-ai"
  />

  {/* Open Graph Tags */}
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:image" content="/images/og-image.jpg" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content={`https://frothtestops.com${location.pathname}`} />

  {/* Twitter Card Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content="/images/og-image.jpg" />
</Helmet>
    <div className={`fd-main-wrapper ${location.pathname !== "/" ? "page-padding" : ""}`}>
      <Header />
        <Introduction />
        <TestCase />
        <CreatingTestCase />

      <Footer />
    </div>
    </>
  );
};

export default FrothAI;
